import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { SearchAccessLayout } from 'pages/conversations/pages/search/layout/SearchAccessLayout'
import { SearchPage } from 'pages/conversations/pages/search/ui/searchPage'
import { ProfileRouter } from 'pages/conversations/pages/search/pages/profile'
import { ConversationRoutes } from 'pages/conversations/route/type'

export const SearchRouter = observer(() => {
  return (
    <Routes>
      <Route element={<SearchAccessLayout />}>
        <Route path={'/'} element={<SearchPage />} />
        <Route path={`/${ConversationRoutes.profile}/*`} element={<ProfileRouter />} />
      </Route>
    </Routes>
  )
})
